export default "__VITE_ASSET__Bn$VyYQR__"